exports.quotas = [
  { code: "VC00", name: "cash" },
  { code: "VC02", name: "2 quotas" },
  { code: "VC03", name: "3 quotas" },
  { code: "VC06", name: "6 quotas" },
  { code: "VC10", name: "10 quotas" },
  { code: "VC12", name: "12 quotas" },
  { code: "VC15", name: "15 quotas" },
  { code: "VC18", name: "18 quotas" },
  { code: "VC24", name: "24 quotas" },
  { code: "VC36", name: "36 quotas" },
  { code: "VC48", name: "48 quotas" },
  { code: "LU", name: "points redemption" },
];
